// extracted by mini-css-extract-plugin
export default {"later":"already-set_up-business_later__Qofoq","multiform":"already-set_up-business_multiform__XmYmu"};